<template>
  <iColumn gap="extraSmall" width="fill">
    <iText font-weight="strong">
      {{ entity?.authorName || 'User' }}
    </iText>
    <iText>
      {{ entity?.message || entity?.text || 'This is a sample user message.' }}
    </iText>
  </iColumn>
</template>

<script>
// `%/components/community/chatrooms/comments/...` lives outside the
// editor directory tree. Canvas preview reads off the example entity.
import { StoryCommentElementMixin } from "%/dynamic-component-editor/standard-components/story-comment/story-comment-element-mixin";
import { ActionElementMixin } from "%/dynamic-component-editor/standard-elements/action-element/action-element-mixin";

export default {
  name: "UserMessageBody",
  elementPanelSettings: {
    displayIcon: "paragraph",
    elementGroup: "User Messages",
    elementType: "element",
  },
  mixins: [StoryCommentElementMixin, ActionElementMixin],
};
</script>
